module.exports = __webpack_public_path__ + "img/der_02_xrobot_a.b3777ee1.png";